"use strict";export function isSharedValue(value){return!0===value?._isReanimatedSharedValue}